/**
 * passkey-budget WP0 (docs/security/passkey-budget.md §1.4): allowing a secret needs a passkey.
 *
 * Every approval surface (session card, Inbox, voice, notification "Allow") sends `run.approve`.
 * A daemon refuses one that would ALLOW a pending `viko_run_with_secret` request with
 * `SECRET_NEEDS_PASSKEY`; the backend then re-sends the same decision as the risky
 * `secret.approve`, which takes a passkey step-up (and joins the approval tray).
 */
import { type CommandPayload, SECRET_NEEDS_PASSKEY } from '@viko/protocol'
import type { CommandOutcome } from './types.js'

export function secretApprovalRetry(
  kind: string,
  payload: unknown,
  out: Pick<CommandOutcome, 'status' | 'error'>,
): CommandPayload<'secret.approve'> | undefined {
  if (kind !== 'run.approve' || out.status !== 'failed') return undefined
  if (!out.error?.startsWith(SECRET_NEEDS_PASSKEY)) return undefined
  const p = payload as CommandPayload<'run.approve'>
  if (p.decision !== 'allow' && p.decision !== 'allow_always') return undefined
  return { requestId: p.approvalId, decision: p.decision }
}

export const SECRET_APPROVAL_SUMMARY = 'Allow a command to use a secret'
